import React, { useEffect, useState } from "react";
import dashboard_icon from "../assets/dashboard_icon.png";
import tools_icon from "../assets/tools_icon.png";
import data_icon from "../assets/data_icon.png";
import billing_icon from "../assets/billing_icon.png";
import user_icon from "../assets/user_icon.png";
import "./TabBar.css";
import API_GATEWAY_URL from "../config";

const tabs = [
  { label: "Dashboard", icon: dashboard_icon },
  { label: "Tools", icon: tools_icon },
  { label: "Data", icon: data_icon },
  { label: "Billing", icon: billing_icon },
  { label: "Profile", icon: user_icon },
];

function TabBar({ selectedTab, onTabChange }) {
  const [isAdmin, setIsAdmin] = useState(false);

  const handleTabClick = (tab) => {
    onTabChange(tab.label);
  };

  useEffect(() => {
    // Fetch user profile every 5 minutes (adjust the interval as needed)
    let isFetching = false;
    const fetch_user_profile_and_refresh_token = async () => {
      if (isFetching) return;
      isFetching = true;
      try {
        // Retrieve authorization token from local storage
        const jwt_token = localStorage.getItem("palm_care_token");
        const apiUrl = `${API_GATEWAY_URL}/user/profile`;

        // Make the API request with authorization header
        const response = await fetch(apiUrl, {
          headers: {
            Authorization: jwt_token,
          },
        });

        // Handle the response as needed
        const data = await response.json();
        setIsAdmin(data.user.is_admin === 1);

        // Retrieve authorization token from local storage
        const apiUrl_2 = `${API_GATEWAY_URL}/token/generate`;

        // Make the API request with authorization header
        const response_2 = await fetch(apiUrl_2, {
          headers: {
            'Authorization': jwt_token,
            'X-Token-Type': 'JWT'
          },
        });

        // Handle the response as needed
        const data_2 = await response_2.json();
        localStorage.setItem('palm_care_token', data_2.jwt_token);
        localStorage.setItem('palm_care_email', data_2.email);
        localStorage.setItem('palm_care_group', data_2.group);

      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        isFetching = false;
      }
    };

    // Fetch user profile initially and then every 5 minutes
    fetch_user_profile_and_refresh_token();
    const intervalId = setInterval(fetch_user_profile_and_refresh_token, 0.5 * 60 * 1000);

    // Clear the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const filteredTabs = isAdmin ? tabs : tabs.filter((tab) => tab.label !== "Admin");

  return (
    <div className="tab__bar__container">
      {filteredTabs.map((tab) => (
        <div
          key={tab.label}
          className={`tab__item ${selectedTab === tab.label ? "selected" : ""}`}
          onClick={() => handleTabClick(tab)}
        >
          <img src={tab.icon} alt={tab.label} className="tab__item__logo" />
          <span>{tab.label}</span>
        </div>
      ))}
    </div>
  );
}

export default TabBar;
